"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.initializeI18n = void 0;
var tslib_1 = require("tslib");
var i18next_1 = tslib_1.__importDefault(require("i18next"));
var i18next_browser_languagedetector_1 = tslib_1.__importDefault(require("i18next-browser-languagedetector"));
var react_i18next_1 = require("react-i18next");
function initializeI18n(options) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, i18next_1.default
                        // detect user language
                        // learn more: https://github.com/i18next/i18next-browser-languageDetector
                        .use(i18next_browser_languagedetector_1.default)
                        // pass the i18n instance to react-i18next.
                        .use(react_i18next_1.initReactI18next)
                        // init i18next
                        // for all options read: https://www.i18next.com/overview/configuration-options
                        .init(tslib_1.__assign({ fallbackLng: options.resources ? Object.keys(options.resources)[0] : undefined, debug: process.env.NODE_ENV === 'development', interpolation: { escapeValue: false } }, options))];
                case 1:
                    _a.sent();
                    return [2 /*return*/, i18next_1.default];
            }
        });
    });
}
exports.initializeI18n = initializeI18n;
//# sourceMappingURL=I18n.js.map